BinderEvent = window.BinderEvent = (function () {
    return {
        bind: function (justLoaded) {
        },
        unBind: function () {
        },
        name: 'BinderEvent',
        url: '/Event/GetViewSet',
    }
}());

//--------------------------------------------

ScopeEvent = window.ScopeEvent = (function () {

    function init() {
        app.VerticalMenu.hide();
        MainNavigation.updatePage();

        app.OpenEvent.init();

        if (app.OpenEvent.EventInstance.isLive) {
            app.Search.init('live');
        } else {
            app.Search.init('prematch');
        }
    }

    function dispose() {
        app.OpenEvent.dispose();
    }

    return {
        start: function (justLoaded) {
            init();
        },
        stop: function () {
            dispose();
        },
        name: 'ScopeEvent',
        url: 'EVENT',
    };
}());